import { TextField, MenuItem, Box, Typography } from "@mui/material";
import moment from "moment";

const months = [
  { month: "January", alias: "01" },
  { month: "February", alias: "02" },
  { month: "March", alias: "03" },
  { month: "April", alias: "04" },
  { month: "May", alias: "05" },
  { month: "June", alias: "06" },
  { month: "July", alias: "07" },
  { month: "August", alias: "08" },
  { month: "September", alias: "09" },
  { month: "October", alias: "10" },
  { month: "November", alias: "11" },
  { month: "December", alias: "12" },
];

export default function DashboardFilter({years, handleYearFilterChange}) {
    return (
      <Box sx={{ display: { xs: "block", sm: "flex", md: "flex" }, alignItems: "center" }}>
        <Typography variant="h5" sx={{ marginBottom:{ xs: "10px", sm: 0 } }}>Filter:</Typography>
        <TextField
          label="Month"
          size="small"
          select
          defaultValue={moment().format("MM")}
          sx={{width:"150px",marginBottom: { xs: "20px", sm: 0 },marginLeft: { xs: "0px", sm: "10px" }}}
        >
            {months.map((month, index)=>{
                return <MenuItem key={index} value={month.alias}>{month.month}</MenuItem>
            })}
        </TextField>

        <TextField
          label="Year"
          size="small"
          defaultValue={moment().format("YYYY")}
          select
          onChange={handleYearFilterChange}
          sx={{ width:"150px", marginBottom: { xs: "20px", sm: 0 }, marginRight: { xs: "0px", sm: "50px" } }}
        >
          {years.map((year, index) => {
            return (
              <MenuItem key={index} value={year}>{year}</MenuItem>
            );
          })}
        </TextField>
      </Box>
    );
}